import router from '~/core/router';
import { CancellationRoute } from '~/modules/cancellation';

router.addPrivateRoutes([CancellationRoute]);
